var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['loader', { fullsize: _vm.fullsize, absolute: _vm.absolute }]},[(_vm.black)?_c('LoaderBlack'):_c('LoaderWhite')],1)}
var staticRenderFns = []

export { render, staticRenderFns }